import { useState, useEffect } from 'react';

interface QuizHookProps {
  onStart: () => void;
}

export default function QuizHook({ onStart }: QuizHookProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="flex items-center justify-center min-h-screen px-6 py-12">
      <div className={`max-w-2xl w-full text-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
          What's secretly slowing your growth?
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-700 mb-4 leading-relaxed">
          92% of founders who take this discover they have a hidden leak.
        </p>
        
        <p className="text-base text-gray-600 mb-12">
          You probably have a problem you haven't seen yet.
        </p>
        
        <div className="mb-8">
          <p className="text-sm text-gray-500">
            6 questions. Takes 30 seconds.
          </p>
        </div>

        <button
          onClick={onStart}
          className="bg-gray-900 text-white px-10 py-5 rounded-lg text-lg font-semibold hover:bg-gray-800 hover:scale-105 transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          Start
        </button>
      </div>
    </section>
  );
}